<script>
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2021 (original work) Open Assessment Technologies SA ;
    import { Icon } from '@oat-sa-private/ui-elements';

    export let message = '';
    export let icon = '';
</script>

{#if icon}
    <Icon name={icon} />
{/if}
<span class="ribbon-message">{message}</span>
